<template>
  <div class="dashboard-item">
    <div class=" d-flex align-items-center dashboard-item__header">
      <h4 class="border-none m-0 p-0">Recent Activity</h4>
      <small-spinner v-if="ui.loading"/>
    </div>
    <div class="list">
      <div class="row">
        <div class="col-4">Lead</div>
        <div class="col-4">Status Changed</div>
        <div class="col">Notes</div>
        <div class="col"></div>
      </div>
      <div class="dashboard-item__body scrollable" id="recent-activity">
        <div class="row" v-for="(activity, index) in activities" :key="index">
          <div class="col-4 my-auto">
            <router-link
              :to="{ name: 'lead_info', params: { id: activity.uuid } }"
              class="lead-links"
            >
              {{ activity.leads }}
            </router-link>
          </div>
          <div class="col-4 my-auto of-hidden">{{ activity.status }}</div>
          <div class="col my-auto">
            <button @click="showNotes(activity.uuid, activity.leads)"
                    class="btn-note"
                    content="Show Notes" v-tippy="{ placement : 'bottom',  arrow: true }">
              <img src="@/assets/images/icons/icon-notes.svg" alt="Notes"/>
            </button>
          </div>
          <div class="col text-right dsb-date my-auto">{{ activity.statusedAt }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SmallSpinner from "../../../components/SmallSpinner";

export default {
  name: 'RecentActivityItems',
  components: {SmallSpinner},
  data() {
    return {
      activities: [],
      ui: {
        loading: false,
      }
    }
  },
  beforeMount() {
    this.getActivity();
  },
  methods: {
    getActivity() {
      this.ui.loading = true;
      this.$http
        .get('/api/v1/leads/activity')
        .then((res) => (this.activities = res.data))
        .catch((err) => console.log(err))
        .finally(() => this.ui.loading = false)
    },
    showNotes(id, name) {
      this.$emit('showNotes', {id, name});
    }
  }
}
</script>
